

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '../../../config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import { fetchMantenedorCapacitaciones } from './fetchMantenedorCapacitaciones';
import CardsCategoria from './CardsCategoria.vue';

import {
  OpcionesApi,
  ItemsApi,
  ParamsApi,
} from './models/Capacitaciones.model';

@Component({
  components: { CardsCategoria },
})
export default class ModalCapacitaciones extends Vue {
  @Prop({ required: true, default: 0 }) categoria: number;
  @Prop({ required: true, default: [] }) items!: ItemsApi[];

  readonly funcionalidad: Funcionalidades = Funcionalidades.capacitaciones;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  activeBtn: number = 0;
  dialog: boolean = false;
  loadingModal: boolean = false;
  data: OpcionesApi[] = [];
  item: number = 0;

  @Watch('categoria')
  validarCategoria() {
    this.data = [];
    this.handleShowCategorias();
  }

  async handleShowCategorias() {
    this.data = await this.getOpciones({
      idcategoria: this.categoria,
      item: this.item,
    });
  }

  showModal({ item = 1 }) {
    if (this.activeBtn === item) {
      this.dialog = !this.dialog;
      this.activeBtn = 0;
      return;
    }
    this.data = [];
    this.dialog = true;
    this.activeBtn = item;
    this.item = item;
    this.handleShowCategorias();
  }

  async getOpciones({ idcategoria, item }: ParamsApi): Promise<OpcionesApi[]> {
    let self = this;
    this.loadingModal = true;
    this.loadingService.showLoading();
    return fetchMantenedorCapacitaciones({
      endpoint: 'get_opciones',
      body: {
        idcategoria,
        item,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        return cod !== 1 || MENSAJE_RESPUESTA ? [] : LISTA;
      })
      .catch((err: Error) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor reintente más tarde',
          { timeout: 3000 }
        );
        throw err;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        this.loadingModal = false;
      });
  }
}
